import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import {TheMask} from 'vue-the-mask'

import AreaRepository from '@/shared/http/repositories/configuration/area'
import InsuranceRepository from '@/shared/http/repositories/configuration/insurance'
import StageRepository from '@/shared/http/repositories/configuration/stage'
import SchedulingTypeRepository from '@/shared/http/repositories/configuration/schedulingtype'

import LighthouseRepository from '@/shared/http/repositories/regulation/lighthouse'
import LighthouseModel from '@/shared/models/regulation/lighthousemodel'
import LighthouseForms from './lighthouse-form'

export default {
  name: 'lighthuose',
  mixins: [ActionsForm],
  data () {
    return {
      data: LighthouseModel,
      form: LighthouseForms
    }
  },
  components: {
    TheMask
  },
  mounted () {
    this.onLoadAllArea()
    this.onLoadAllSchedulingType()
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.TipMaximumSize.replace('@SIZE@', this.maxlengthFieldName)
    },
    StartYellow: function () {
      /*
      var result = ''
      if (parseInt(this.form.green.value)) {
        result = parseInt(this.form.green.value) + 1
      }
      return result
      */
      return this.form.green.value
    },
    StartRed: function () {
      /*
      var result = ''
      if (parseInt(this.form.yellow.value)) {
        result = parseInt(this.form.yellow.value) + 1
      }
      return result
      */
      return this.form.yellow.value
    }
  },
  methods: {
    onLoad () {
      loading.push()
      LighthouseRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      loading.push()

      this.form.insuranceID.options = []
      this.form.stageID.options = []

      Tools.SetValueInForm(this.form, this.data, obj)
      // --> Set manual
      this.onChangeArea()
      var self = this
      setTimeout(function (e) {
        self.form.insuranceID.value = obj.insuranceID
        self.form.stageID.value = obj.stageID
        self.form.schedulingContactID.value = obj.schedulingContactID
      }, 900)

      loading.pop()
    },
    onCreate () {
      loading.push()
      LighthouseRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      LighthouseRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      LighthouseRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllArea () {
      loading.push()
      AreaRepository.GetAll()
        .then((response) => {
          this.form.areaID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllInsurer (id) {
      this.form.insuranceID.options = []
      if (id) {
        loading.push()
        InsuranceRepository.GetAllByAreaID(id)
          .then((response) => {
            this.form.insuranceID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onLoadAllStage (id) {
      this.form.stageID.options = []
      if (id) {
        loading.push()
        StageRepository.GetAll()
          .then((response) => {
            this.form.stageID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onChangeArea () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllInsurer(self.form.areaID.value)
        self.onLoadAllStage(self.form.areaID.value)
        self.onLoadAllSchedulingType(self.form.areaID.value)
      }, 500)
    },
    onLoadAllSchedulingType (id) {
      SchedulingTypeRepository.GetAll()
        .then((response) => {
          var result = []
          var type = response.data
          if (type && type.data && type.count > 0) {
            var data = type.data
            for (var i in data) {
              if (data[i].status) {
                result.push({ 'text': data[i].name, 'value': data[i].id })
              } else {
                result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
              }
            }
            this.form.schedulingTypeID.options = result
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/lighthouse/lighthouse.js